import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import EmptyGroupsFigure from "../../../../assets/images/empty-groups-figure.png";
import { getEntityGroupCreateRoute } from "../../../../../../routers/routeUtils";

const NoGroups = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "groups" });
  const navigate = useNavigate();
  const { entityId } = useParams();
  return (
    <Box
      sx={{
        border: "1px solid #EAECF0",
        background: "#FFF",
        padding: "80px 24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "32px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <img
          src={EmptyGroupsFigure}
          alt="empty-groups-figure"
          style={{
            width: "158px",
            height: "120.248px",
          }}
        />
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Typography
            sx={{
              color: "var(--Dark---600, #707070)",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "24px",
            }}
          >
            {t("noGroups")}
          </Typography>
          <Typography
            sx={{
              color: "var(--Dark---600, #707070)",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "24px",
            }}
          >
            {t("startExploring")}
          </Typography>
        </Box>
      </Box>
      <Button variant="primary-sm" onClick={() => navigate(getEntityGroupCreateRoute(entityId!))}>
        {t("createFirstGroup")}
      </Button>
    </Box>
  );
};

export default NoGroups;
